import { render, staticRenderFns } from "./CategoriaList.vue?vue&type=template&id=ab2667c4&scoped=true"
import script from "./CategoriaList.vue?vue&type=script&lang=js"
export * from "./CategoriaList.vue?vue&type=script&lang=js"
import style0 from "./CategoriaList.vue?vue&type=style&index=0&id=ab2667c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2667c4",
  null
  
)

export default component.exports